import './AboutIntro.css';

function AboutIntro() {
  return (
    <section className="about-intro">
      <div className="about-intro-container">
        <div className="about-intro-text">
          <h3>Chi siamo</h3>
          <p>
            La Consulta è un Organismo Istituzionale apartitico di rappresentanza giovanile del
            Comune di Ortona, nato nel 2012, che si ispira alla "Carta europea della partecipazione dei giovani alla
            vita locale e regionale" ed è aperta ai cittadini dai 15 ai 35 anni residenti nel territorio comunale.
            Propone progetti ed iniziative come ricerche, incontri con gruppi e Istituzioni e proposte di
            deliberazione.
          </p>
          <p>
            Lo sviluppo del benessere giovanile è il fine principale delle azioni e delle
            iniziative intraprese dalla Consulta pertanto, con l'idea di avvicinare sempre più giovani alla vita
            politica, al di fuori della realtà partitica, abbiamo intrapreso un percorso di collaborazione con le
            associazioni del territorio che hanno generato attività di beneficenza e investimento locale tramite
            raccolte fondi e acquisto di materiali da donare a scuole, società sportive e edifici pubblici.
          </p>
          <p>
            Dal 2019 portiamo avanti un progetto sulla legalità e sulla lotta alle mafie, nato
            dal senso di appartenenza alla causa e giustizia sociale presenti nei principi fondamentali della
            Consulta Giovanile.
          </p>
        </div>
        <div className="about-intro-image">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/consulta-giovanile-di-ortona.appspot.com/o/immagini%20sito%2Fchi%20siamo-min.jpeg?alt=media&token=02fcbb80-d27f-4ade-b10d-3078a3646c01"
            alt="Chi siamo"
          />
        </div>
      </div>
    </section>
  );
}

export default AboutIntro;
